export const uploadConstants = {
  UPLOAD_IMAGE_REQUEST: 'UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCES',
  UPLOAD_IMAGE_FAILURE: 'UPLOAD_IMAGE_FAILURE',
};
